import React from 'react';
import { useIntl } from 'react-intl';

import { Select } from '~/eds/src/components/Select/Select';

type AvailableProps =
  | 'disabled'
  | 'error'
  | 'placeholder'
  | 'value'
  | 'width'
  | 'onChange'
  | 'name';
interface Props extends Pick<
  React.ComponentProps<typeof Select>,
  AvailableProps
> {}

function BooleanSelect({
  disabled = false,
  error,
  placeholder,
  value,
  width,
  onChange,
  name,
}: Props) {
  const intl = useIntl();

  const options = [
    {
      value: true,
      label: intl.formatMessage({
        id: 'BooleanSelect.isTrue',
        defaultMessage: 'is true',
        description: 'Label for true boolean option',
      }),
    },
    {
      value: false,
      label: intl.formatMessage({
        id: 'BooleanSelect.isFalse',
        defaultMessage: 'is false',
        description: 'Label for false boolean option',
      }),
    },
  ];

  return (
    <Select
      enablePortal={true}
      isMulti={false}
      disabled={disabled}
      error={error}
      isClearable={false}
      options={options}
      placeholder={placeholder}
      value={value}
      width={width}
      onChange={onChange}
      name={name}
    />
  );
}

export default BooleanSelect;
